import MidiPlayer from "./MidiPlayer";

export default MidiPlayer;